"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableMoneyCell = void 0;
var common_constants_1 = require("../../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("../bc-data-table-constants");
var BcDataTableMoneyCell = (function () {
    function BcDataTableMoneyCell() {
    }
    BcDataTableMoneyCell.prototype.render = function (cell) {
        var parsedNumber = parseFloat(cell.value);
        if (Number.isNaN(parsedNumber)) {
            return this._createErrorMessage(cell.class);
        }
        var numberFormat = this._getNumberFormat(cell.number_format);
        var formattedAbsoluteNumber = this._getFormattedNumber(Math.abs(parsedNumber), numberFormat);
        var decimalSeparator = this._getDecimalSeparator(bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_DEFAULT_LOCAL);
        var _a = formattedAbsoluteNumber.split(decimalSeparator), integerString = _a[0], decimalString = _a[1];
        var mathSignElements = parsedNumber < 0 ? [this._createMinusSignElement()] : [];
        var moneySignElement = this._createMoneySignElement(cell.money_intl_prefix);
        var integerElement = this._createIntegerElement(integerString);
        var decimalElement = this._createDecimalElement(decimalString, decimalSeparator);
        var elementsToAdd = __spreadArray(__spreadArray([], mathSignElements, true), [moneySignElement, integerElement, decimalElement], false);
        var moneyCell = this._createMoneyCell();
        moneyCell.append.apply(moneyCell, elementsToAdd);
        this._updateAriaLabels(moneyCell, cell.money_intl_prefix, cell.money_symbol_aria_label);
        var mainCell = this._createMainCell(cell.class);
        mainCell.appendChild(moneyCell);
        return mainCell;
    };
    BcDataTableMoneyCell.prototype._createElement = function (tag, classname, value) {
        var element = document.createElement(tag);
        element.classList.add(classname);
        element.textContent = value;
        return element;
    };
    BcDataTableMoneyCell.prototype._createErrorMessage = function (elementClass) {
        var mainCell = this._createMainCell(elementClass);
        mainCell.textContent = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_PARSE_ERROR_MESSAGE;
        return mainCell;
    };
    BcDataTableMoneyCell.prototype._createMainCell = function (elementClass) {
        if (elementClass === void 0) { elementClass = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_DEFAULT_CLASS; }
        var mainCell = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        mainCell.classList.add(elementClass);
        return mainCell;
    };
    BcDataTableMoneyCell.prototype._createMoneyCell = function () {
        var moneyCell = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        moneyCell.classList.add(bc_data_table_constants_1.BcDataTableConstansts.ALIGN_RIGHT);
        return moneyCell;
    };
    BcDataTableMoneyCell.prototype._createMinusSignElement = function () {
        return this._createElement(common_constants_1.BcCommonConstants.SPAN_TAG, bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_CLASS_SYMBOL, bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_MINUS_SIGN);
    };
    BcDataTableMoneyCell.prototype._createMoneySignElement = function (_moneySymbol) {
        var moneySymbol = this._getMoneySignElement(_moneySymbol);
        return this._createElement(common_constants_1.BcCommonConstants.SPAN_TAG, bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_CLASS_SYMBOL, "".concat(moneySymbol, " "));
    };
    BcDataTableMoneyCell.prototype._getMoneySignElement = function (moneySymbol) {
        if (moneySymbol === void 0) { moneySymbol = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_DEFAULT_SYMBOL; }
        return moneySymbol;
    };
    BcDataTableMoneyCell.prototype._createIntegerElement = function (integerString) {
        return this._createElement(common_constants_1.BcCommonConstants.SPAN_TAG, bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_CLASS_INTEGER, integerString);
    };
    BcDataTableMoneyCell.prototype._createDecimalElement = function (decimalString, decimalSeparator) {
        return this._createElement(common_constants_1.BcCommonConstants.SPAN_TAG, bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_CLASS_DECIMAL, "".concat(decimalSeparator).concat(decimalString));
    };
    BcDataTableMoneyCell.prototype._updateAriaLabels = function (moneyCell, _moneySymbol, customAriaLabelSuffix) {
        this._hideAriaOnChildren(moneyCell);
        moneyCell.ariaLabel = this._getAriaLabel(moneyCell, _moneySymbol, customAriaLabelSuffix);
    };
    BcDataTableMoneyCell.prototype._getAriaLabel = function (moneyCell, _moneySymbol, customAriaLabelSuffix) {
        var minusSignForAccessibility = this._getAccessibilityMinusSignText();
        var baseText = moneyCell.textContent;
        var updatedText = baseText.replace(bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_MINUS_SIGN, minusSignForAccessibility);
        var moneySymbol = this._getMoneySignElement(_moneySymbol);
        return customAriaLabelSuffix
            ? updatedText.replace(moneySymbol, '').concat(" ".concat(customAriaLabelSuffix))
            : updatedText;
    };
    BcDataTableMoneyCell.prototype._hideAriaOnChildren = function (element) {
        Array.from(element.children).forEach(function (el) {
            el.ariaHidden = 'true';
        });
    };
    BcDataTableMoneyCell.prototype._getDecimalSeparator = function (locale) {
        var NUMBER_WITH_DECIMAL = 1.1;
        var NUMBER_SUBSTRING = 2;
        return NUMBER_WITH_DECIMAL.toLocaleString(locale).substring(1, NUMBER_SUBSTRING);
    };
    BcDataTableMoneyCell.prototype._getFormattedNumber = function (numberValue, numberFormat, locale) {
        if (locale === void 0) { locale = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_DEFAULT_LOCAL; }
        return new Intl.NumberFormat(locale, numberFormat).format(numberValue);
    };
    BcDataTableMoneyCell.prototype._getNumberFormat = function (numberFormat) {
        if (numberFormat === void 0) { numberFormat = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_DEFAULT_FORMAT; }
        return numberFormat;
    };
    BcDataTableMoneyCell.prototype._getAccessibilityMinusSignText = function () {
        var signElement = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        signElement.innerHTML = bc_data_table_constants_1.BcDataTableConstansts.CELL_MONEY_ACCESSIBILITY_MINUS_SIGN;
        return signElement.textContent;
    };
    return BcDataTableMoneyCell;
}());
exports.BcDataTableMoneyCell = BcDataTableMoneyCell;
